// extracted by mini-css-extract-plugin
export default {"root":"_35G4fL9k"};